import { EVENT_COLORS } from 'pages/Calendar/constants';

export const DROPDOWN_WIDTH = 320;
export const DROPDOWN_HEIGHT = 380;
const SIDEBAR_WIDTH = 200;

export const LEFT_EXTRA = SIDEBAR_WIDTH + DROPDOWN_WIDTH / 2;
export const COLOR_ITEM_SIZE = (DROPDOWN_WIDTH - 32) / EVENT_COLORS.length - 8;
